import type { Effect, Reducer } from 'umi';
import {
  getWorkflowUserPage,
  workflowUserStreetVerify,
  workflowUserDistrictVerifyPre,
  workflowUserDistrictVerify,
} from './service';
import type { SingleWorkflowUserType } from './data';

export type WorkflowUserModelState = {
  items: SingleWorkflowUserType[];
  total: number;
  current: number;
  pageSize: number;
};

export type WorkflowUserModelType = {
  namespace: 'workflowUser';
  state: WorkflowUserModelState;
  effects: {
    fetchWorkflowUserPageEffect: Effect;
    refreshDataEffect: Effect;
    streetVerifyEffect: Effect;
    districtVerifyPreEffect: Effect;
    districtVerifyEffect: Effect;
  };
  reducers: {
    setWorkflowUserPage: Reducer<WorkflowUserModelState>;
  };
};

const WorkflowUserModel: WorkflowUserModelType = {
  namespace: 'workflowUser',

  state: {
    items: [],
    total: 0,
    current: 1,
    pageSize: 20,
  },

  effects: {
    *fetchWorkflowUserPageEffect({ payload }, { call, put }) {
      const response = yield call(getWorkflowUserPage, payload);
      if (response.code === 0) {
        yield put({
          type: 'setWorkflowUserPage',
          payload: response.data,
        });
      }
      return response;
    },

    *refreshDataEffect({ payload }, { call }) {
      const response = yield call(getWorkflowUserPage, payload);
      return response;
    },

    *streetVerifyEffect({ payload, callback }, { call, put }) {
      const response = yield call(workflowUserStreetVerify, payload.values);
      if (response.code === 0) {
        yield put({
          type: 'fetchWorkflowUserPageEffect',
          payload: {
            current: payload.current,
            pageSize: payload.pageSize,
            filter: payload.filter,
            sorter: payload.sorter,
          },
        });
      }
      if (callback) callback(response);
      return response;
    },

    *districtVerifyPreEffect({ payload, callback }, { call }) {
      const response = yield call(workflowUserDistrictVerifyPre, payload.values);
      if (callback) callback(response);
      return response;
    },

    *districtVerifyEffect({ payload, callback }, { call, put }) {
      const response = yield call(workflowUserDistrictVerify, payload.values);
      if (response.code === 0) {
        yield put({
          type: 'fetchWorkflowUserPageEffect',
          payload: {
            current: payload.current,
            pageSize: payload.pageSize,
            filter: payload.filter,
            sorter: payload.sorter,
          },
        });
      }
      if (callback) callback(response);
      return response;
    },
  },

  reducers: {
    setWorkflowUserPage(state, action) {
      return {
        ...state,
        items: action.payload.items || [],
        total: action.payload.total || 0,
        current: action.payload.current || 1,
        pageSize: action.payload.pageSize || 20,
      };
    },
  },
};

export default WorkflowUserModel;
